import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import connect from '../../connect';
import { routeToContentPage } from '../../../actions/route';

class PageJump extends React.Component {
    static propTypes = {
        routeToContentPage: PropTypes.func.isRequired,
        content: PropTypes.object,
        pageLabel: PropTypes.string,
    };

    state = {
        pageLabel: this.props.pageLabel,
        inputId: _.uniqueId('_courseload'),
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ pageLabel: nextProps.pageLabel });
    }

    handleChange = e => {
        this.setState({ pageLabel: e.target.value });
    };

    handleFormSubmit = e => {
        e.preventDefault();
        const { content } = this.props;
        const page = content.pages.find(function(tmpPage) {
            return tmpPage.label === this.state.pageLabel;
        }, this);

        if (page) {
            this.props.routeToContentPage({
                contentId: content.id,
                pagenum: page.pagenum,
            });
        } else {
            alert('page not found'); // eslint-disable-line no-alert

            this.setState({
                pageLabel: this.props.pageLabel,
            });
        }
    };

    render() {
        const { inputId } = this.state;
        return (
            <div className="go-to-page">
                <form onSubmit={this.handleFormSubmit}>
                    <label htmlFor={inputId} className="aural">
                        Go to page
                        <span className="secondary">(Optional)</span>
                    </label>
                    {/* The key here will force it to gernate a new input any
                        time you change pages.
                        key is using props while value is using state.
                     */}
                    <input
                        arial-label="Page Number"
                        id={inputId}
                        key={this.props.pageLabel}
                        name="page_number"
                        onChange={this.handleChange}
                        type="text"
                        value={this.state.pageLabel}
                    />
                </form>
            </div>
        );
    }
}

export default connect(
    null,
    {
        routeToContentPage,
    }
)(PageJump);



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/jump_to_page.jsx